









































































import { Component, Vue } from "vue-property-decorator";
import { CategoryList } from "../models/CategoryList";
import DropdownList from "../components/form/DropdownList.vue";
import { LookupService } from "../services/LookupService";

@Component({
  components: {
    DropdownList
  },
  name: "CategorySearch"
})
export default class CategorySearch extends Vue {
  searchCategory = 0;
  showProgressIndicator = false;
  levels: CategoryList[] = [];
  private lookupService = new LookupService();

  private maxLevel = 3;

  addLevel(level: number): void {
    this.clearLevel(level);
    this.getLevel(level);
  }

  removeLevel(level: number): void {
    this.clearLevel(level);

    if (this.levels.length > 0) {
      this.searchCategory = this.levels[this.levels.length - 1].categoryId;
      if (this.searchCategory > 0) {
        this.getLevel(this.levels.length);
      }
    }
  }

  clearLevel(level: number): void {
    if (level < 0) {
      level = 0;
    }

    // Remove all levels above the current one.
    while (this.levels.length > level) {
      this.levels.pop();
    }
  }

  getLevel(level: number): void {
    let newLevel = level;
    if (newLevel > this.levels.length) {
      newLevel = this.levels.length;
    }

    if (newLevel < 0) {
      newLevel = 0;
    }

    if (newLevel === this.maxLevel) {
      newLevel = this.maxLevel;
    }

    const parentCategory =
      newLevel === 0 ? 0 : this.levels[newLevel - 1].categoryId;

    this.showProgressIndicator = true;

    this.lookupService
      .GetCategories(parentCategory)
      .then(response => {
        if (response.length === 0) {
          this.clearLevel(newLevel + 1);
          return;
        }
        if (this.levels.length > newLevel) {
          this.levels[newLevel].list = response;
          this.levels[newLevel].categoryId = 0;
        } else {
          this.levels.push({
            list: response,
            categoryId: 0,
            active: false
          });
        }
        this.showProgressIndicator = false;
      })
      .catch(error => {
        console.log(error);
        this.showProgressIndicator = false;
      });
  }

  categorySelected(level: number): void {
    if (level >= 0 && level < this.levels.length) {
      if (this.levels[level].categoryId > 0) {
        this.searchCategory = this.levels[level].categoryId;
        if (level <= this.maxLevel) {
          this.addLevel(level + 1);
        }
      } else {
        this.removeLevel(level + 2);
        if (level > 0) {
          this.searchCategory = this.levels[level - 1].categoryId;
        }
      }
    }
  }

  canSubmit(level: number): boolean {
    return (
      this.searchCategory > 0 &&
      ((level === 0 && this.levels.length === 1) ||
        (level === this.levels.length - 2 &&
          this.levels[level + 1].categoryId === 0) ||
        (this.levels[level].categoryId > 0 &&
          level === this.levels.length - 1 &&
          !this.canRefine(level)))
    );
  }

  canRefine(level: number): boolean {
    return (
      level > 0 &&
      level === this.levels.length - 1 &&
      this.levels[level].categoryId === 0
    );
  }

  canRemove(level: number): boolean {
    return level > 0 && this.canSubmit(level);
  }

  selectOptionLabel(level: number): string {
    if (level > 0) {
      return "Select sub-category";
    }
    return "Select category";
  }

  gotFocus(level: number): void {
    this.levels[level].active = true;
  }

  lostFocus(level: number): void {
    this.levels[level].active = false;
  }

  created(): void {
    this.getLevel(0);
  }
}
